import linkifyHtml from 'linkify-html'

// v-linkify: turns plain URLs/emails in the element's HTML into anchors.
// Explicit target keeps the linkifyjs-v2 default of opening links in a new tab.
export default {
    mounted(el, binding) {
        el.innerHTML = linkifyHtml(el.innerHTML, { target: '_blank', ...(binding.value || {}) })
    },
}
